import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportObraServicosControladosUseCase } from "../../../presentation/useCases/read/get_report_obra_servicos_controlados_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportObraServicosControladosUseCase
 */

export class GetReportObraServicosControladosUseCase implements IGetReportObraServicosControladosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportObraServicosControlados(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportObraServicosControlados(requiredMimeType);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `servicos_controlados_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
